<div class="adhesive-banner" *ngIf="blogService.adhesiveBannersVisible">
	<div class="ohio-terms-condition" *ngIf="adBanner && this.locationData?.state_name?.toLowerCase() === 'ohio'">
		<fa-icon class="warn" [icon]="faTriangleExclamation"></fa-icon>
		Must be in Ohio. 21+.
		<fa-icon class="phone" [icon]="faPhone"></fa-icon>
		Gambling Problem? Call 1-800-GAMBLER
	</div>
	<div class="ohio-terms-condition" *ngIf="adBanner && this.locationData?.state_name?.toLowerCase() === 'massachusetts'">
		<span>Must be 21+. Gambling problem? Call 1-800-327-5050 or visit <a href="https://helplinema.org" target="_blank">https://helplinema.org</a>. Restrictions and T&Cs Apply.</span>
	</div>
	<div
		*ngIf="adBanner"
		class="adhesive-banner-holder"
		[style.background-color]="adBanner.background_color ? adBanner.background_color : 'initial'"
	>
		<div
			class="adhesive-banner-container"
			[style.maxWidth]="adBanner.max_width ? adBanner.max_width + 'px' : '1110px'"
		>
			<div align="center" justify="center" class="height-100 banner-row row">
				<div
					cols="0"
					md="2"
					class="d-none banner-container d-md-flex d-md-none height-100 desktop-image"
				>
					<picture *ngIf="adBanner.logo?.dynamic_url">
						<source [srcset]="adBanner.logo.dynamic_url + '?w=640&fm=webp'" type="image/webp">
						<source [srcset]="adBanner.logo.dynamic_url + '?w=640'" [type]="adBanner.logo.mime_type">
						<img
							[alt]="adBanner.logo.custom_properties.alt_text"
							[src]="adBanner.logo.dynamic_url + '?w=640'"
							class="m-left-10 banner-image"
							(click)="openBanner(adBanner.logo_url, adBanner.bookmaker_code)"
							loading="lazy"
						>
					</picture>
				</div>
				<div
					cols="8"
					md="8"
					align="center"
					justify="center"
					class="height-100 banner-desc-container"
				>
					<div class="banner-desc">
						<p
							class="heading m-0 f-bold f-20"
							[style.color]="adBanner.heading_color ? adBanner.heading_color : 'FFF'"
						>
							{{ adBanner.heading }}
						</p>
						<p
						class="desc m-0 f-12"
						[style.color]="adBanner.description_color ? adBanner.description_color : 'FFF'"
						[style.font-size]="adBanner.description_font_size ? adBanner.description_font_size + 'px' : '11px'"
						>
							{{ adBanner.description }}
						</p>
					</div>
				</div>
				<div cols="4" md="2" class="height-100 banner-container">
					<div class="close-btn pointer"
						[class.black]="this.locationData?.state_name?.toLowerCase() === 'ohio' || this.locationData?.state_name?.toLowerCase() === 'massachusetts'"
					>
						<fa-icon [icon]="faTimes" (click)="blogService.disableAdhesiveBanners()"></fa-icon>
					</div>
					<picture *ngIf="adBanner.logo?.dynamic_url">
						<source [srcset]="adBanner.logo.dynamic_url + '?w=640&fm=webp'" type="image/webp">
						<source [srcset]="adBanner.logo.dynamic_url + '?w=640'" [type]="adBanner.logo.mime_type">
						<img
							[alt]="adBanner.logo.custom_properties.alt_text"
							[src]="adBanner.logo.dynamic_url + '?w=640'"
							class="m-left-20 banner-image-mob d-sm-flex d-md-none"
							(click)="openBanner(adBanner.logo_url, adBanner.bookmaker_code)"
							loading="lazy"
						>
					</picture>
					<a 	
						attr.data-recording-click-props='{
							"offer-bookmaker": "{{ adBanner.bookmaker_code }}",
							"offer-bookmaker-id": "{{ adBanner.id }}",
							"offer-component": "ad-banner",
							"offer-state-code": "{{ this.stateCode }}"
						}'
						class="btn-join"
						:small="$vuetify.breakpoint.smAndDown"
						[style.color]="adBanner.button_text_color"
						[style.font-weight]="700"
						(click)="openBanner(adBanner.logo_url, adBanner.bookmaker_code)"
						[style.background-color]="adBanner.button_color ? adBanner.button_color : 'initial'"
					>
						{{ adBanner.button_text ? adBanner.button_text : 'Join Now' }}
					</a>
				</div>
			</div>
		</div>
	</div>
</div>